import OrderDataList from './OrderDataList';

export default OrderDataList;
